import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import { CONTEXT_GET_PROFIL } from '../../constants/apiUrls.constants';

const profil = combineReducers({
    usager: APIReducer.bind(null, CONTEXT_GET_PROFIL),
});

export default profil;
